export default "__VITE_ASSET__kuZkjkJ8__"